<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import EstateObjectData = App.Data.EstateObject.EstateObjectData
import ProjectData = App.Data.Project.ProjectData
import Pills from '@/components/Pills.vue'
import EstateObject from '@/pages/banks/financing-request/EstateObject.vue'
import AttachmentData = App.Data.AttachmentData

const props = defineProps<{
  estateObjects: EstateObjectData[]
  project: ProjectData
  attachments: AttachmentData[]
}>()

const { t } = useI18n()

const selectedView = ref(props.estateObjects[0]?.id ?? '')

const objectPills = computed(() =>
  props.estateObjects.map((estateObject, index) => ({
    value: estateObject.id ?? '',
    label: estateObject.title || t('object_fallback_label', { number: index + 1 }),
  })),
)

const selectedEstateObject = computed(
  () => props.estateObjects.find((estateObject) => estateObject.id === selectedView.value) ?? props.estateObjects[0],
)
</script>

<template>
  <div v-if="selectedEstateObject" class="flex flex-col gap-6">
    <Pills v-if="estateObjects.length > 1" v-model="selectedView" :options="objectPills" />
    <div class="flex flex-col gap-4">
      <EstateObject
        :estate-object="selectedEstateObject"
        :project="project"
        :estate-object-count="estateObjects.length"
        :attachments="attachments" />
    </div>
  </div>
</template>

<i18n>
{
  "de": {
    "object_fallback_label": "Objekt {number}"
  },
  "en": {
    "object_fallback_label": "Object {number}"
  }
}
</i18n>
